import styles from "./DesktopCommonSlider.module.css";
import {
  CarouselProvider,
  Slider,
  Slide,
  Dot,
  ButtonBack,
  ButtonNext,
  ButtonFirst,
  ButtonLast,
} from "pure-react-carousel";
import "pure-react-carousel/dist/react-carousel.es.css";
import { useNavigate } from "react-router-dom";
import MediaAssets from "assets";
import { Typography } from "@mui/material";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useSelector } from "react-redux";

const DesktopCommonSlider = (prop: any) => {
  const { sliderData } = prop;

  const navigate = useNavigate();

  const handleRiderct = (data: any) => {
    if (prop.setToTop && (prop.toTop === false || prop.toTop === true)) {
      if (prop?.toTop === true) {
        prop?.setToTop(false);
      } else {
        prop?.setToTop(true);
      }
    }

    navigate(`/investment-details/${data.launchName.replace(/%20|\s/g, "-")}`, {
      state: {
        projectId: data.id,
        area: data?.areaStartingFrom,
        cost: data.priceStartingFrom,
        title: data.launchName,
        location: data.address.city,
        description: data.shortDescription,
        isDetailed: data.isSoldOut,
        isExplore: data.isSoldOut,
        isSold: data.isSoldOut,
        dataAsObject: data,
        // medias: medias[index],
      },
    });
  };

  return (
    <>
      <div className={styles.sliderCon}>
        <CarouselProvider
          naturalSlideWidth={100}
          naturalSlideHeight={54}
          totalSlides={sliderData?.length}
          infinite
          // isPlaying={true}
          interval={10000}
          visibleSlides={1.3}
        >
          <Slider>
            {sliderData &&
              sliderData?.map((data: any, index: any) => {
                // if (data?.status !== "1001") {
                //   return;
                // }
                if (!data) return null;
                return (
                  <Slide
                    index={index}
                    onClick={() => {
                      handleRiderct(data);
                    }}
                    style={{ cursor: "pointer" }}
                    key={index}
                    className="slider-wrapper"
                  >
                    <div
                      className={styles.sliderContainer}
                      style={{ height: "100%", width: "90%" }}
                    >
                      {/* <div className={styles.icon}>
                        <LazyLoadImage
                          className={styles.iconImg}
                          src={data?.projectIcon?.value?.url}
                        />
                      </div> */}
                      <div style={{ height: "100%", width: "100%" }}>
                        <LazyLoadImage
                          src={
                            data?.projectCoverImages?.homePageMedia?.value?.url
                          }
                          className={styles.feature_card_img_style}
                        />
                      </div>
                      <div className={styles.bottomDivStyle}>
                        <div className={styles.feature_card_content}>
                          <div>
                            <h2 className={styles.feature_card_h2_content}>
                              {data?.pdpDisplayName ?? data?.launchName}
                            </h2>
                            <h3 className={styles.feature_card_h3_content}>
                              {`${data?.address?.city}`}
                              {data?.address?.state
                                ? `, ${data?.address?.state} `
                                : ""}
                            </h3>
                          </div>
                          <div style={{ marginTop: "10px" }}>
                            <h4 className={styles.feature_card_h4_content}>
                              {data?.shortDescription}
                            </h4>
                          </div>
                        </div>
                        <div className={styles.areaPriceBtn}>
                        <div className={styles.areaPrice}>
                              {data?.isVilla ? (
                                <>
                                  <div className={styles.area}>
                                    {data?.sku}{" "}
                                  </div>
                                </>
                              ) : (
                                <>
                                  <div className={styles.area}>
                                    {data?.areaStartingFrom}{" "}
                                    <span className={styles.fetText}>
                                      sq ft
                                    </span>
                                  </div>
                                </>
                              )}
                              {data?.isVilla ? (
                                <>
                                  <div className={styles.price}>
                                    ₹
                                    {parseInt(
                                      data?.skuPrice.replace(/,/g, "")
                                    ) /
                                      100000 >
                                    100
                                      ? (
                                          parseInt(
                                            data?.skuPrice.replace(/,/g, "")
                                          ) /
                                          100000 /
                                          100
                                        ).toFixed(2) + " CR"
                                      : (
                                          parseInt(
                                            data?.skuPrice.replace(/,/g, "")
                                          ) / 100000
                                        ).toFixed(2) + " L"}<span style={{fontSize:'medium'}}>+ </span>
                                    <span className={styles.onwordsText}>
                                      onwards
                                    </span>
                                  </div>
                                </>
                              ) : (
                                <>
                                  <div className={styles.price}>
                                    ₹
                                    {data?.priceStartingFrom / 100000 > 100
                                      ? (
                                          data?.priceStartingFrom /
                                          100000 /
                                          100
                                        ).toFixed(2) + " CR"
                                      : (
                                          data?.priceStartingFrom / 100000
                                        ).toFixed(2) + " L"}<span style={{fontSize:'medium'}}>+ </span>
                                    <span className={styles.onwordsText}>
                                      onwards
                                    </span>
                                  </div>
                                </>
                              )}
                            </div>
                          <div
                            className={styles.active_btn}
                            onClick={() => {
                              handleRiderct(data);
                            }}
                          >
                            <LazyLoadImage
                              src={MediaAssets.edit_active_icon}
                              className={styles.edit_active_icon_style}
                            />
                            <div className={styles.active_content_position}>
                              <LazyLoadImage
                                src={MediaAssets.Ic_button_world_icon}
                                alt=""
                                className={styles.wordIcon}
                              />
                              <Typography
                                id={styles.active_content_explore}
                                style={{
                                  fontFamily: "Futura Md BT",
                                  fontSize: "16px",
                                }}
                                className={styles.ExploreNowText}
                              >
                                Explore Now
                              </Typography>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Slide>
                );
              })}
          </Slider>
          <div className={styles.controls}>
            <ButtonBack className={styles.nextLeftBtn}>
              <KeyboardArrowLeftIcon className={styles.nextBtnIcon} />
            </ButtonBack>
            <ButtonNext className={styles.nextBtn}>
              <KeyboardArrowRightIcon className={styles.nextBtnIcon} />
            </ButtonNext>
          </div>
          <div className={styles.dot_wrapper}>
            {sliderData &&
              sliderData?.map((data: any, index: any) => {
                return (
                  <Dot slide={index} key={index} className={styles.dot_style} />
                );
              })}
          </div>
        </CarouselProvider>
      </div>
    </>
  );
};

export default DesktopCommonSlider;
